module.exports = __webpack_public_path__ + "img/지역사회.e7572d57.svg";